import React from "react";
import { motion } from "framer-motion";
import { MessageCircle, Filter, Gauge, Repeat, CalendarCheck, Database } from "lucide-react";

const features = [
  {
    icon: MessageCircle,
    title: "Instant WhatsApp reply",
    body: "Every enquiry is greeted in under 5 seconds, 24/7, so no lead ever sits cold in an inbox again.",
  },
  {
    icon: Filter,
    title: "Smart qualification",
    body: "Asks tailored, industry-specific questions and interprets replies in real time to understand fit.",
  },
  {
    icon: Gauge,
    title: "Intent scoring & tagging",
    body: "Auto-scores each lead Hot / Warm / Cold and tags them so your team prioritises instantly.",
  },
  {
    icon: Repeat,
    title: "Adaptive follow-ups",
    body: "Sends smart, human-sounding nudges and reminders until the lead responds or converts.",
  },
  {
    icon: CalendarCheck,
    title: "Appointment booking",
    body: "Books qualified leads straight into Calendly, Google Calendar or your CRM, hands-free.",
  },
  {
    icon: Database,
    title: "Instant CRM & Sheets sync",
    body: "Pushes every qualified lead to Google Sheets, HubSpot, Zoho or Pipedrive the moment it scores.",
  },
];

export const Features = () => (
  <section id="how" className="bg-silver-100/70 py-28 sm:py-32" data-testid="features">
    <div className="mx-auto max-w-6xl px-5">
      <div className="mb-14 flex flex-col items-start justify-between gap-6 md:flex-row md:items-end">
        <div className="max-w-2xl">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-brand">How it works</span>
          <h2 className="mt-4 font-display text-4xl font-black tracking-tighter text-charcoal sm:text-5xl">
            One agent. The entire top of your funnel.
          </h2>
        </div>
        <p className="max-w-sm text-base text-silver-700">
          From first hello to booked meeting, Digimonk.AI runs the busywork so your closers stay closing.
        </p>
      </div>

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {features.map((f, i) => (
          <motion.div
            key={f.title}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
            className="group rounded-2xl border border-silver-300/60 bg-white p-7 transition-all duration-300 hover:-translate-y-1 hover:border-brand/50 hover:shadow-[0_18px_40px_rgb(0,0,0,0.06)]"
            data-testid={`feature-${i}`}
          >
            <span className="mb-5 flex h-12 w-12 items-center justify-center rounded-xl bg-brand-light text-brand-dark transition-colors group-hover:bg-brand group-hover:text-white">
              <f.icon className="h-6 w-6" />
            </span>
            <h3 className="font-display text-xl font-bold tracking-tight text-charcoal">{f.title}</h3>
            <p className="mt-2.5 text-sm leading-relaxed text-silver-700">{f.body}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default Features;
